import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Home',
    icon: 'home',
    link: '/pages/dashboard',
    home: true,
    hidden: false,
  },
  {
    title: 'Vendas',
    icon: 'monitor-outline',
    link: '/pages/menus/vendas',
    hidden: false,
  },
  {
    title: 'Admin',
    icon: 'shield-outline',
    hidden: true,
    link: '/pages/menus/gestao',
  },
  {
    title: 'Relatórios',
    icon: 'pie-chart-outline',
    link: '/pages/menus/relatorios',
    hidden: false,
  },
  {
    title: 'Lançamentos',
    icon: 'monitor-outline',
    link: '/pages/menus/lancamentos',
    hidden: false,
  },
  {
    title: 'Cambio',
    icon: 'monitor-outline',
    link: '/pages/menus/cambio',
    hidden: false,
  },
];

/** Mapeamento índice sidebar → chave do grupo no banco */
export const SIDEBAR_GRUPO_CHAVES: Record<number, string> = {
  1: 'vendas',
  2: 'gestao',
  3: 'relatorios',
  4: 'lancamentos',
  5: 'cambio',
};
